import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const TopInstructionAndLink = props => {
  const { link, text } = props;
  return (
    <div className="instruction-and-link">
      {link ? (
        <Link to={link}>
          <span className="icon-left-arrow" />
        </Link>
      ) : null}
      {text && <p>{text}</p>}
    </div>
  );
};

TopInstructionAndLink.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
};

export default TopInstructionAndLink;
